import { z } from 'zod';
export const getZapsCheckoutSessionUrlPathSchema = z.object({
    subdomain: z.string(),
});
export const getZapsCheckoutSessionUrlBodySchema = z.object({});
export const getZapsCheckoutSessionUrlInputSchema = getZapsCheckoutSessionUrlPathSchema.merge(getZapsCheckoutSessionUrlBodySchema);
export const getZapsCheckoutSessionUrlOutputSchema = z.object({
    checkoutUrl: z.string().url(),
});
